/**
 * Reading a week's absence rows.
 *
 * Kept out of the component file so both stay fast-refresh eligible, the same
 * split `components/budget/format.js` uses.
 */
export const ABSENCE_KINDS = ['vacation', 'leave']

export function absenceHours(data, memberId, kind) {
  if (!data) return 0
  const row = data.rows.find(r => r.team_member_id === memberId && r.kind === kind)
  return row ? row.hours : 0
}

export function absenceTotal(data, memberId) {
  return ABSENCE_KINDS.reduce((sum, kind) => sum + absenceHours(data, memberId, kind), 0)
}
